module.exports = __webpack_public_path__ + "static/media/HighlightBadOptimized.c3ae2973.jp2";